namespace TabAurous.ProductDevelopment {
    export namespace SpecSheetService {
        export const baseUrl = 'ProductDevelopment/SpecSheet';

        export declare function Create(request: Serenity.SaveRequest<SpecSheetRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SpecSheetRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SpecSheetRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SpecSheetRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ImportSpecSheet(request: ExcelImportRequest, onSuccess?: (response: Common.ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/SpecSheet/Create",
            Update = "ProductDevelopment/SpecSheet/Update",
            Delete = "ProductDevelopment/SpecSheet/Delete",
            Retrieve = "ProductDevelopment/SpecSheet/Retrieve",
            List = "ProductDevelopment/SpecSheet/List",
            ImportSpecSheet = "ProductDevelopment/SpecSheet/ImportSpecSheet"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ImportSpecSheet'
        ].forEach(x => {
            (<any>SpecSheetService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
